import { forAllCallback } from "kwp-core/scripts/utils/helpers";

export default () => {
    const queryString = window.location.search;

    if (
        queryString.length &&
        (queryString.includes("room_function") ||
            queryString.includes("room_capacity"))
    ) {
        forAllCallback(".back-to-search .button", (el) => {
            el.style.display = "inline-flex";
            el.addEventListener("click", (e) => {
                e.preventDefault();
                window.history.back();
            });
        });
    } else {
        // remove the padding from the section
        forAllCallback(".content-block--back-to-search", (el) => {
            el.style.padding = "0";
        });
    }
};
